import React from "react";
import { createRoot } from 'react-dom/client';
import HistoryCardsBlock from '../components/HistoryCardsBlock';

const renderHistoryCardsBlock = () => {
	const historyCardsBlock = document.getElementById('history-cards-block');

	if (historyCardsBlock) {
		const root = createRoot(historyCardsBlock);
		root.render(<HistoryCardsBlock language={historyCardsBlock.dataset.lang} />);
	}
}

export default renderHistoryCardsBlock;